import Vue from "vue";

Vue.component("objectives", {
	props: ["domain", "language", "loadingText", "objectiveIds", "isReadOnly"],
	data() {
		return {
			listObjectives: [],
			selectedObjectives: [],
			loading: false
		};
	},
	methods: {
		getObjectives: function () {
			this.loading = true;
			this.$services.objectives.getForCheckbox({
				domain: this.domain,
				language: this.language
			})
				.then((data) => {
					this.loading = false;					
					this.listObjectives = data.items;
					if (this.objectiveIds.length > 0) {
						this.selectedObjectives = this.objectiveIds;
					}
				});
		},
		checkIfSelected: function (value) {
			let result = false;
			if (value) {
				let objective = this.objectiveIds.filter(item => item == value);
				result = objective.length > 0;
			}
			return result;
		}
	},
	watch: {
		selectedObjectives: function (val) {
			this.$emit("update:objectiveIds", val);
		}
	},
	mounted() {
		this.getObjectives();
	},
	template: `
		<div v-if="loading">
			<loading :loading-text="loadingText"></loading>
		</div>
		<div v-else>
			 <b-field :key="item.value" v-for="item in listObjectives">
				<b-checkbox v-if="!isReadOnly" v-model="selectedObjectives" :native-value="item.value">
					{{ item.text }}
				</b-checkbox>

				<label v-else class="b-checkbox checkbox is-disabled">
					<input type="checkbox" disabled="disabled" true-value="true" :checked="checkIfSelected(item.value)" />
					<span class="check"></span>
					<span class="control-label">
						{{ item.text }}
					</span>
				</label>
			</b-field>
		</div>
	`
});